import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addProductStart, fetchProductsStart, deleteProductStart } from './../redux/Products/products.actions';
import Modal from './../components/Modal';
import FormInput from './../components/forms/FormInput';
import FormSelect from './../components/forms/FormSelect';
import Button from './../components/forms/Button';

const mapState = ({ productsData }) => ({
  products: productsData.products
});


const Admin = props => {
  const { products } = useSelector(mapState);
  const dispatch = useDispatch();
  const [hideModal, setHideModal] = useState(true);
  const [productCategory, setProductCategory] = useState('plans');
  const [productName, setProductName] = useState('');
  const [productPrice, setProductPrice] = useState(0);
  const [productDesc, setProductDesc] = useState('');

  const { data } = products;
  

  useEffect(() => {
    dispatch(
      fetchProductsStart()
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])

  const toggleModal = () => setHideModal(!hideModal);

  const configModal = {
    hideModal,
    toggleModal
  };

  const resetForm = () => {
    setHideModal(true);
    setProductCategory('plans');
    setProductName('');
    setProductPrice(0);
    setProductDesc('');
  };


  const handleSubmit = e => {
    e.preventDefault();

    dispatch(
      addProductStart({
        productCategory,
        productName,
        productPrice,
        productDesc
      })
    );
    resetForm();

  };

  
  return (
    <div className="admin mt-5">

      <div className="callToActions">
        <ul>
          <li>
            <Button onClick={() => toggleModal()}>
              Add new product
            </Button>
          </li>
        </ul>
      </div>

      <Modal {...configModal}>
        <div className="addNewProductForm">
          <form onSubmit={handleSubmit}>

            <h2>
              Add new product
            </h2>

            <FormSelect
              label="Category"
              options={[{
                value: "Plans",
                name: "Plans"
              }, {
                value: "Add-ons",
                name: "Add-Ons"
              }, {
                value: "Vendor Service",
                name: "Vendor Service"
              }, {
                value: "Vendor Pay-Per Service",
                name: "Vendor Pay-Per Service"
              }]}
              handleChange={e => setProductCategory(e.target.value)}
            /> 

            <FormInput
              label="Name"
              type="text"
              value={productName}
              handleChange={e => setProductName(e.target.value)}
            />
            
            <FormInput
              label="Price"
              type="number"
              min="0.00"
              max="10000.00"
              step="0.01"
              value={productPrice}
              handleChange={e => setProductPrice(e.target.value)}
            />

            {/* <CKEditor
              onChange={evt => setProductDesc(evt.editor.getData())}
            /> */}
            <label htmlFor="Description" className="text-dark">Product Description</label><br />
            <textarea value={productDesc} id="Description" name="Description" rows="4" cols="50" onChange={e => setProductDesc(e.target.value)}></textarea>

            <br />
            <br />

            <Button type="submit">
              Add product
            </Button>

          </form>
        </div>
      </Modal>

      <div className="manageProducts pb-5">

        <table border="0" cellPadding="0" cellSpacing="0">
          <tbody>
            <tr>
              <th>
                <h1>
                  Manage Products
                </h1>
              </th>
            </tr>
            <tr>
              <td>
                <table className="results" border="0" cellPadding="10" cellSpacing="0">
                  <tbody>
                  
                    {(Array.isArray(data) && data.length > 0) && data.map((product, index) => {
                      const {
                        productName,
                        productCategory,
                        productPrice,
                        documentID,
                        productDesc
                      } = product;
                      
                      return (
                        <tr key={index}>
                          <td>
                            {productCategory}
                          </td>
                          <td>
                            {productName}
                          </td>
                          <td>
                            ${productPrice}
                          </td>
                          <td>
                            {productDesc}
                          </td>
                          <td>
                            <Button onClick={() => dispatch(deleteProductStart(documentID))}>
                              Delete
                            </Button>
							            
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>

              </td>
            </tr>
            
          </tbody>
        </table>

      </div>

    </div>
  );
}

export default Admin;
